
import { Button } from "@/components/ui/button";
import { Building, User } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

import { useLanguage } from "@/contexts/LanguageContext";


const CrowdsourcedSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-16 bg-gradient-to-br from-nexus-teal/5 to-nexus-yellow/5" id="crowdsourced">
      <div className="container">
        <div className="relative max-w-4xl mx-auto">
          {/* Decorative elements */}
          <div className="absolute -top-6 -right-6 w-12 h-12 rounded-full bg-nexus-yellow/20 animate-pulse"></div>
          <div className="absolute -bottom-6 -left-6 w-12 h-12 rounded-full bg-nexus-teal/20 animate-pulse"></div>

          <Card className="overflow-hidden border-0 shadow-lg">
            <div className="bg-nexus-gray p-6 text-white text-center">
              <Badge variant="outline" className="border-nexus-yellow text-nexus-yellow uppercase font-semibold mb-3">
                {t("crowdSourced.label")}
              </Badge>
              <h2 className="text-3xl md:text-4xl font-bold mb-3"> {t("crowdSourced.title")}</h2>
              <p className="text-gray-100 mb-0 max-w-lg mx-auto">
                {t("crowdSourced.description")}
              </p>
            </div>

            <CardContent className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="text-center p-6 bg-gray-50 rounded-lg">
                  <div className="w-16 h-16 mx-auto rounded-full bg-nexus-teal/10 flex items-center justify-center mb-4">
                    <Building className="w-8 h-8 text-nexus-teal" />
                  </div>
                  <h3 className="text-xl font-semibold text-nexus-gray mb-3"> {t("crowdSourced.businessOwners.title")}</h3>
                  <p className="text-gray-600 mb-6">
                    {t("crowdSourced.businessOwners.description")}
                  </p>
                  <Button asChild className="h-auto min-h-10 w-full whitespace-normal py-2 text-center leading-snug bg-nexus-brand hover:bg-nexus-brand/90">
                    <a
                      href="https://forms.gle/qtHJdTpVeXA5Ueft5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("crowdSourced.businessOwners.button")}
                    </a>
                  </Button>
                </div>

                <div className="text-center p-6 bg-gray-50 rounded-lg">
                  <div className="w-16 h-16 mx-auto rounded-full bg-nexus-yellow/10 flex items-center justify-center mb-4">
                    <User className="w-8 h-8 text-nexus-yellow" />
                  </div>
                  <h3 className="text-xl font-semibold text-nexus-gray mb-3"> {t("crowdSourced.testers.title")} </h3>
                  <p className="text-gray-600 mb-6">
                    {t("crowdSourced.testers.description")}
                  </p>
                  <Button asChild className="h-auto min-h-10 w-full whitespace-normal py-2 text-center leading-snug bg-nexus-yellow hover:bg-nexus-yellow/90 text-[#3A3E47]">
                    <a
                      href="https://forms.gle/NyRcYwMgKmFupeeX9"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("crowdSourced.testers.button")}
                    </a>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default CrowdsourcedSection;
